<div class="fixed bottom-0 left-0 right-0 z-50 flex overflow-x-auto p-1 gap-2 window-bar-container">
  <ng-container *ngFor="let win of minimizedWindows$ | async">
    <div class="flex items-center gap-2 px-2 py-1 bg-[var(--main-light)] rounded-full shadow window-taskbar-item"
      [ngClass]="{
        'modified': win.isModified,
        'active': win.isActive
      }">
      <span class="window-title-ellipsis text-sm">{{ win.title || (win.type + ' #' + win.id) }}</span>
      <button mat-icon-button color="primary" (click)="restore(win)" matTooltip="Restaurer"
        class="transition-transform hover:scale-110 active:scale-95">
        <mat-icon>open_in_full</mat-icon>
      </button>
      <button mat-icon-button color="warn" (click)="close(win)" matTooltip="Fermer"
        class="transition-transform hover:scale-110 active:scale-95">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </ng-container>
</div>